import type { IconSvgObject } from './types';

const HeartPlusIcon: IconSvgObject = [
  ["path", { d: "M15 15.4999H21M18 12.4999V18.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 19.656C13.8577 19.7655 13.7205 19.8695 13.5893 19.9676C12.6399 20.6775 11.3601 20.6775 10.4107 19.9676C7.58942 17.8578 2 13.0347 2 8.69432C2 5.82551 4.10526 3.49988 7 3.49988C8.5 3.49988 10 3.99988 12 5.99988C14 3.99988 15.5 3.49988 17 3.49988C19.8947 3.49988 22 5.82551 22 8.69432C22 9.28984 21.8948 9.89444 21.7059 10.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HeartPlusIcon;
